<template>
  <div class="foot">
    <div class="footer_box clear">
      <p>江苏传智播客教育科技股份有限公司版权所有 <br>Copyright 2006-2023， All Rights Reserved<br><a href="http://www.beian.miit.gov.cn" rel="nofollow" target="_blank">苏ICP备16007882号-11</a></p> 
    </div>
    <div class="bdzx" @click="childMethod"><a class="zx_btn" href="JavaScript:;">在线咨询</a> <a class="tel_btn" href="JavaScript:;">我要报名</a></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    };
  },
  methods: {
    childMethod() {
      this.$parent.itcastClick();
    }
  }
};
</script>

<style lang="less" scoped>
.foot {
  .footer_box{background: #eee;padding: 30px 0 120px;}
  .footer_box p{font-size: 28px;text-align: center;color: #000;}
  .bdzx{width:100%; height:100px; background: #1BAAF8; position: fixed; bottom:0; left:0; z-index: 999;}
  .bdzx a{ line-height:100px;font-size: 34px; color: #fff; display: block; float: left; width:49%; height:100px; text-align: center;box-sizing: border-box;padding-left: 6%;}
  .bdzx a.zx_btn{border-right: 1px solid #fff; background: url('http://www.itheima.com/templates/subject/images/qq_icon.jpg') no-repeat 26% center; background-size: 10%;}
  .bdzx a.tel_btn{ background: url('http://www.itheima.com/templates/subject/images/phone_bg.jpg') no-repeat 26% center; background-size: 12%;padding-left: 8%;}
}
</style>
